import { useStorage } from './useStorage';
export const useLocalStorage = (key, initialValue, onError) => useStorage(() => window.localStorage, key, initialValue, onError);
